import React from 'react';
import {Check} from 'lucide-react';
import {useLang} from './i18n';
import {HoverTip} from './HoverTip';

// BOT label; bots approved in the admin dashboard show a check mark and APP. Only the check mark has the tooltip.
export function BotTag({verified}:{verified?:boolean}){
 const [,,tr]=useLang();
 if(!verified)return <span className="bot-tag">BOT</span>;
 return <span className="bot-tag is-verified"><HoverTip className="bot-tag-check" label={tr('Verified app','Verifizierte App')}><Check size={11} strokeWidth={3} aria-hidden="true"/></HoverTip>APP</span>;
}
